document.addEventListener('DOMContentLoaded', function () {
  const skuDisplay = document.createElement('div');
  skuDisplay.id = 'live-sku-display';
  skuDisplay.textContent = 'SKU: -';
  skuDisplay.style.display = 'none';

  const stockStatus = document.createElement('div');
  stockStatus.id = 'stock-status';
  stockStatus.style.fontSize = '0.9em';
  stockStatus.style.marginTop = '4px';

  const productForm = document.querySelector('form[action^="/cart/add"]');
  if (productForm) {
    productForm.insertAdjacentElement('beforebegin', stockStatus);
    productForm.insertAdjacentElement('beforebegin', skuDisplay);
  }

  let availableSkus = [];
  let availableSkuSet = new Set();

  // Centralized SKU maps (step 1): domains to avoid collisions
  window.skuMaps = window.skuMaps || {
    titles: {
      BARON: 'B', BARONESS: 'BF', DUCHESS: 'DF', DUKE: 'D', VISCOUNT: 'V', VISCOUNTESS: 'VF',
      COUNT: 'C', COUNTESS: 'CF', MARQUIS: 'M', MARQUISE: 'MF',
      'LE BARON, GATINEAU': 'GAT', 'BARON & BARONESS': 'BF', 'DUKE & DUCHESS': 'DF',
      'VISCOUNT & VISCOUNTESS': 'VF', 'COUNT & COUNTESS': 'CF', 'MARQUIS & MARQUISE': 'MF'
    },
    // Accepts 'M'/'N' or full words
    types: { M: 'M', N: 'N', MUNICIPALITY: 'M', NEIGHBOURHOOD: 'N' },
    provinces: window.provinceToSkuPartMap || {},
    // Cities and neighbourhoods come from the existing global flat map to retain coverage
    cities: window.labelToSkuPartMap || {},
    neighbourhoods: window.labelToSkuPartMap || {}
  };

  // (step 2): helpers for normalization and domain lookups
  function normalizeLabel(input) {
    return (input || '')
      // Remove diacritics (accents) - é->e, è->e, ï->i, etc.
      .normalize('NFD').replace(/\p{Diacritic}/gu, '')
      // Handle specific special characters that might appear in location names
      .replace(/[àáâãäå]/g, 'a')
      .replace(/[èéêë]/g, 'e')
      .replace(/[ìíîï]/g, 'i')
      .replace(/[òóôõö]/g, 'o')
      .replace(/[ùúûü]/g, 'u')
      .replace(/[ýÿ]/g, 'y')
      .replace(/[ñ]/g, 'n')
      .replace(/[ç]/g, 'c')
      .replace(/[æ]/g, 'ae')
      .replace(/[œ]/g, 'oe')
      .replace(/[ß]/g, 'ss')
      // Remove price indicators and other non-alphanumeric content
      .replace(/\s*\(.*?\)/, '')
      .replace(/\s*\$.*$/, '')
      .trim()
      .toUpperCase();
  }

  function getFragment(label, domain) {
    const n = normalizeLabel(label);
    const maps = window.skuMaps || {};
    const domainMap = maps[domain] || {};
    return domainMap[n] || '';
  }

  // Heuristic: ensure municipality type suffixes for known prefixes
  function ensureMunicipalityTypeSuffix(label, code) {
    if (!code) return code;
    const n = normalizeLabel(label);
    if (n.startsWith('HAMLET OF ') && !/-H$/.test(code)) return `${code}-H`;
    // Northern Hamlet uses -NH suffix in inventory
    if ((n.startsWith('NORTHERN HAMLET OF ') || n.startsWith('NORTHERN HAMLET ')) && !/-NH$/.test(code)) return `${code}-NH`;
    if (n.startsWith('MUNICIPALITY OF ') && !/-M$/.test(code)) return `${code}-M`;
    if (n.startsWith('COMMUNITY OF ') && !/-CO$/.test(code)) return `${code}-CO`;
    if (n.startsWith('COMMUNITIES OF ') && !/-CM$/.test(code)) return `${code}-CM`;
    if (n.includes('COUNTY') && !/-CT$/.test(code)) return `${code}-CT`;
    if (n.startsWith('TOWN OF ') && !/-T$/.test(code)) return `${code}-T`;
    if (n.startsWith('CITY OF ') && !/-C$/.test(code)) return `${code}-C`;
    if (n.startsWith('VILLAGE OF ') && !/-V$/.test(code)) return `${code}-V`;
    if (n.startsWith('RURAL MUNICIPALITY OF ') && !/-RM$/.test(code)) return `${code}-RM`;
    if (n.startsWith('MUNICIPAL DISTRICT OF ') && !/-MD$/.test(code)) return `${code}-MD`;
    if (n.startsWith('DISTRICT OF ') && !/-D$/.test(code)) return `${code}-D`;
    if (n.includes('REGIONAL DISTRICT') && !/-RG$/.test(code)) return `${code}-RG`;
    if (n.includes('RESORT VILLAGE') && !/-RV$/.test(code)) return `${code}-RV`;
    return code;
  }

  function safelyResetDropdown(dropdown) {
    // Reset to default (first) option
    dropdown.selectedIndex = 0;
  
    // If using Tom Select
    if (dropdown.tomselect) {
      dropdown.tomselect.clear(true);
    } else if (dropdown.choices) {
      dropdown.choices.clearStore();
    } else {
      // Fallback: update UI
      dropdown.dispatchEvent(new Event('input', { bubbles: true }));
    }
  }

  async function fetchAvailableSkus() {
    // Always start with local inventory for fast response
    if (window.availableSkus && window.availableSkus.length > 0) {
      availableSkus = [...window.availableSkus]; // Create a copy
      availableSkuSet = new Set(availableSkus);
      window.availableSkuSet = availableSkuSet;
      if (typeof window.markSoldOptions === 'function') {
        window.markSoldOptions();
      }
      console.log('✅ Available SKUs loaded from local inventory:', availableSkus.length);
    } else {
      console.error('❌ No local inventory available');
      availableSkus = [];
      availableSkuSet = new Set();
      window.availableSkuSet = availableSkuSet;
      if (typeof window.markSoldOptions === 'function') {
        window.markSoldOptions();
      }
    }

    // Then try to sync with webhook in background (non-blocking)
    try {
      const response = await fetch('https://shopify-inventory-webhook.onrender.com/available-skus');
      if (!response.ok) {
        throw new Error(`HTTP ${response.status}: ${response.statusText}`);
      }
      
      const data = await response.json();
      const webhookSkus = data.skus;
      
      // Only update if webhook has FEWER SKUs (indicating purchases were processed)
      // Don't overwrite local changes if webhook has more SKUs
      if (webhookSkus.length < availableSkus.length) {
        availableSkus = webhookSkus;
        availableSkuSet = new Set(availableSkus);
        window.availableSkuSet = availableSkuSet;
        if (typeof window.markSoldOptions === 'function') {
          window.markSoldOptions();
        }
        console.log('🔄 Inventory synced with webhook (purchases processed):', availableSkus.length, 'SKUs');
        
        // Update the display if there are changes
        updateSkuDisplay();
      } else if (webhookSkus.length > availableSkus.length) {
        console.log('ℹ️ Webhook has more SKUs than local (local changes preserved):', webhookSkus.length, 'vs', availableSkus.length);
      } else {
        console.log('ℹ️ Webhook and local inventory counts match');
      }
    } catch (error) {
      console.log('ℹ️ Webhook sync failed, continuing with local inventory:', error.message);
    }
  }

  // Function to get related SKUs for a given SKU
  function getRelatedSkus(sku) {
    const relatedSkus = [];
    
    // Parse the SKU to understand its structure
    const parts = sku.split('-');
    if (parts.length < 4) return relatedSkus;
    
    const [titlePrefix, type, province, city, neighbourhood] = parts;
    const locationPart = [province, city, neighbourhood].join('-');
    
    // Couple's package logic
    if (titlePrefix === 'CF') {
      // Count & Countess package purchased - remove individual Count and Countess
      relatedSkus.push(`C-${type}-${locationPart}`); // Count/Lord
      relatedSkus.push(`CF-${type}-${locationPart}`); // Countess/Lady (same as couple's)
    }
    
    // Individual Count purchased - remove Countess and couple's package
    else if (titlePrefix === 'C') {
      relatedSkus.push(`CF-${type}-${locationPart}`); // Countess/Lady
      relatedSkus.push(`CF-${type}-${locationPart}`); // Couple's package (same as Countess)
    }
    
    // Individual Countess purchased - remove Count and couple's package  
    else if (titlePrefix === 'CF' && !sku.includes('COUPLE')) {
      relatedSkus.push(`C-${type}-${locationPart}`); // Count/Lord
      relatedSkus.push(`CF-${type}-${locationPart}`); // Couple's package (same as Countess)
    }
    
    // Baron & Baroness package logic
    else if (titlePrefix === 'BF') {
      relatedSkus.push(`B-${type}-${locationPart}`); // Baron
      relatedSkus.push(`BF-${type}-${locationPart}`); // Baroness (same as couple's)
    }
    
    // Individual Baron purchased
    else if (titlePrefix === 'B') {
      relatedSkus.push(`BF-${type}-${locationPart}`); // Baroness
      relatedSkus.push(`BF-${type}-${locationPart}`); // Couple's package
    }
    
    // Individual Baroness purchased
    else if (titlePrefix === 'BF' && !sku.includes('COUPLE')) {
      relatedSkus.push(`B-${type}-${locationPart}`); // Baron
      relatedSkus.push(`BF-${type}-${locationPart}`); // Couple's package
    }
    
    // Viscount & Viscountess package logic
    else if (titlePrefix === 'VF') {
      relatedSkus.push(`V-${type}-${locationPart}`); // Viscount
      relatedSkus.push(`VF-${type}-${locationPart}`); // Viscountess (same as couple's)
    }
    
    // Individual Viscount purchased
    else if (titlePrefix === 'V') {
      relatedSkus.push(`VF-${type}-${locationPart}`); // Viscountess
      relatedSkus.push(`VF-${type}-${locationPart}`); // Couple's package
    }
    
    // Individual Viscountess purchased
    else if (titlePrefix === 'VF' && !sku.includes('COUPLE')) {
      relatedSkus.push(`V-${type}-${locationPart}`); // Viscount
      relatedSkus.push(`VF-${type}-${locationPart}`); // Couple's package
    }
    
    return relatedSkus.filter((relatedSku, index, arr) => arr.indexOf(relatedSku) === index); // Remove duplicates
  }

  // Function to remove a SKU and its related SKUs from available inventory after purchase
  function removeSkuFromInventory(sku) {
    const skusToRemove = [sku, ...getRelatedSkus(sku)];
    let removedCount = 0;
    
    skusToRemove.forEach(skuToRemove => {
      if (availableSkuSet.has(skuToRemove)) {
        availableSkuSet.delete(skuToRemove);
        const index = availableSkus.indexOf(skuToRemove);
        if (index > -1) {
          availableSkus.splice(index, 1);
          removedCount++;
        }
      }
    });
    
    if (removedCount > 0) {
      console.log('🗑️ SKU and related SKUs removed from local inventory:', skusToRemove);
      console.log('📊 Remaining inventory count:', availableSkus.length);
      updateSkuDisplay(); // Refresh the display
    } else {
      console.log('⚠️ SKU not found in local inventory (may have been already removed):', sku);
    }
  }

  // Function to check inventory health and log discrepancies
  function logInventoryHealth() {
    const localCount = availableSkus.length;
    const webhookCount = window.availableSkus ? window.availableSkus.length : 0;
    
    console.log('📊 Inventory Health Check:');
    console.log('  - Local working inventory:', localCount);
    console.log('  - Original local inventory:', webhookCount);
    console.log('  - Difference:', webhookCount - localCount);
    
    if (localCount < webhookCount) {
      console.log('  - ✅ Local inventory properly reduced (purchases tracked)');
    } else if (localCount > webhookCount) {
      console.log('  - ⚠️ Local inventory larger than expected');
    } else {
      console.log('  - ℹ️ Local inventory matches original');
    }
  }

  // Function to refresh inventory periodically (background sync)
  function startInventoryRefresh() {
    setInterval(async () => {
      try {
        const response = await fetch('https://shopify-inventory-webhook.onrender.com/available-skus');
        if (!response.ok) {
          throw new Error(`HTTP ${response.status}: ${response.statusText}`);
        }
        
        const data = await response.json();
        const webhookSkus = data.skus;
        
        // Only update if webhook has FEWER SKUs (indicating purchases were processed)
        // Don't overwrite local changes if webhook has more SKUs
        if (webhookSkus.length < availableSkus.length) {
          availableSkus = webhookSkus;
          availableSkuSet = new Set(availableSkus);
          window.availableSkuSet = availableSkuSet;
          if (typeof window.markSoldOptions === 'function') {
            window.markSoldOptions();
          }
          console.log('🔄 Background inventory sync (purchases processed):', availableSkus.length, 'SKUs available');
          updateSkuDisplay(); // Refresh the display
        } else if (webhookSkus.length > availableSkus.length) {
          console.log('ℹ️ Background sync: Webhook has more SKUs than local (local changes preserved)');
        } else {
          console.log('ℹ️ Background sync: Webhook and local inventory counts match');
        }
      } catch (error) {
        console.log('ℹ️ Background sync failed, continuing with local inventory');
      }
    }, 120000); // Sync every 2 minutes (less frequent since we have local inventory)
  }

  function getCleanedLabels() {
    const controls = document.querySelectorAll('.ts-control .item');
    const labels = Array.from(controls)
      .map(el => {
        let text = el.textContent || '';
        text = text.replace(/\s*\(.*?\)/, '').trim();
        // Use normalizeLabel to handle special characters (é->e, í->i, etc.)
        return normalizeLabel(text).replace('-- PLEASE SELECT --', '');
      })
      .filter(label => label !== '');
    
    console.log('🔍 Raw Labels from Dropdowns:', labels);
    return labels;
  }

  function generateSkuFromLabels(labels) {
    // New position-aware mapping using domains
    return labels.map((label, index) => {
      if (index === 0) return getFragment(label, 'titles');
      if (index === 1) return getFragment(label, 'types');
      if (index === 2) return getFragment(label, 'provinces');
      // fourth position can be city or municipality name
      return getFragment(label, 'cities') || getFragment(label, 'neighbourhoods') || label;
    }).join('-');
  }

  function buildMunicipalitySku(labels) {
    const [title, type, province, municipality] = labels;
    const muniCodeRaw = getFragment(municipality, 'cities') || getFragment(municipality, 'neighbourhoods');
    
    // Skip suffix logic for Yukon Territory since it has pre-mapped SKU fragments
    const muniCode = (province === 'YUKON') ? muniCodeRaw : ensureMunicipalityTypeSuffix(municipality, muniCodeRaw);
    
    return [
      getFragment(title, 'titles'),
      getFragment(type, 'types'),
      getFragment(province, 'provinces'),
      muniCode
    ].join('-');
  }

  function buildNeighbourhoodSku(labels) {
    const [title, type, province] = labels;
    const provinceCode = getFragment(province, 'provinces');
    const provincesWithoutCityDropdowns = ['PRINCE EDWARD ISLAND', 'NOVA SCOTIA', 'MANITOBA'];

    // No city dropdown case
    if (labels.length === 4) {
      const nbhLabel = labels[3];
      const nbhCode = ensureMunicipalityTypeSuffix(nbhLabel, getFragment(nbhLabel, 'neighbourhoods'));
      if (nbhCode && nbhCode.includes('-')) {
        const [parentCity, neighbourhoodCode] = nbhCode.split('-');
        return [getFragment(title,'titles'), getFragment(type,'types'), provinceCode, parentCity, neighbourhoodCode].join('-');
      }
      return [getFragment(title,'titles'), getFragment(type,'types'), provinceCode, nbhCode].join('-');
    }

    // With city dropdown
    const cityLabel = labels[3];
    const nbhLabel = labels[4];
    const cityCode = ensureMunicipalityTypeSuffix(cityLabel, getFragment(cityLabel, 'cities'));
    
    // Try to get neighbourhood mapping with city context first
    const cityContextKey = `${nbhLabel}, ${cityLabel}`;
    const contextMapping = getFragment(cityContextKey, 'neighbourhoods');
    const directMapping = getFragment(nbhLabel, 'neighbourhoods');
    const nbhCode = ensureMunicipalityTypeSuffix(nbhLabel, contextMapping || directMapping);
    
    console.log('🔍 Neighbourhood Context Debug:', {
      nbhLabel: nbhLabel,
      cityLabel: cityLabel,
      cityContextKey: cityContextKey,
      contextMapping: contextMapping,
      directMapping: directMapping,
      finalMapping: nbhCode
    });
    
    if (nbhCode && nbhCode.includes('-')) {
      const [parentCity, neighbourhoodCode] = nbhCode.split('-');
      return [getFragment(title,'titles'), getFragment(type,'types'), provinceCode, parentCity, neighbourhoodCode].join('-');
    }
    return [getFragment(title,'titles'), getFragment(type,'types'), provinceCode, cityCode, nbhCode].join('-');
  }

  function generateSkuFromDropdowns() {
    const labels = getCleanedLabels();
    const regionType = labels[1];
    
    console.log('🔍 Labels Debug:', {
      labels: labels,
      labelsLength: labels.length,
      regionType: regionType
    });
    
    if (regionType === 'N' || regionType === 'NEIGHBOURHOOD') {
      // New centralized neighbourhood builder
      return buildNeighbourhoodSku(labels);
    } else {
      // Municipality builder (first four labels)
      return buildMunicipalitySku(labels.slice(0, 4));
    }

    /*
    Legacy logic retained below for reference; replaced by builders above
      // For neighbourhoods, we need to handle the city part differently
      const title = labels[0];
      const type = labels[1];
      const province = labels[2];
      
      // Check if this is a province that doesn't have separate city dropdowns
      const provincesWithoutCityDropdowns = ['PRINCE EDWARD ISLAND', 'NOVA SCOTIA', 'MANITOBA'];
      const isProvinceWithoutCityDropdown = provincesWithoutCityDropdowns.includes(province);
      
      if (isProvinceWithoutCityDropdown) {
        // For provinces without city dropdowns, neighbourhood is at index 3
        let neighbourhood = labels[3];
        
        console.log('🔍 Neighbourhood Logic Debug (No City Dropdown):', {
          title: title,
          type: type,
          province: province,
          neighbourhood: neighbourhood,
          labelsLength: labels.length,
          allLabels: labels
        });
        
        // Get the neighbourhood mapping
        const directMapping = labelToSkuPartMap[neighbourhood];
        const foundMapping = Object.entries(labelToSkuPartMap).find(([key]) => 
          key.toLowerCase() === neighbourhood?.toLowerCase()
        );
        const neighbourhoodMapping = directMapping || foundMapping?.[1];
        
        console.log('🔍 Detailed Mapping Debug:', {
          neighbourhood: neighbourhood,
          directMapping: directMapping,
          foundMapping: foundMapping,
          finalMapping: neighbourhoodMapping,
          hasDirectKey: neighbourhood in labelToSkuPartMap,
          objectKeys: Object.keys(labelToSkuPartMap).filter(key => key.includes('ALBRO') || key.includes('HALIFAX'))
        });
        
        console.log('🔍 Neighbourhood Mapping Debug:', {
          neighbourhood: neighbourhood,
          neighbourhoodMapping: neighbourhoodMapping,
          hasMapping: !!neighbourhoodMapping,
          containsDash: neighbourhoodMapping?.includes('-')
        });
        
        if (neighbourhoodMapping && neighbourhoodMapping.includes('-')) {
          // If the mapping contains a dash, it's in format "PARENT-NEIGHBOURHOOD"
          const [parentCity, neighbourhoodCode] = neighbourhoodMapping.split('-');
          
          // Use mapped codes instead of raw labels
          const titleCode = labelToSkuPartMap[title] || title;
          const typeCode = labelToSkuPartMap[type] || type;
          const provinceCode = window.provinceToSkuPartMap[province] || province;
          
          return `${titleCode}-${typeCode}-${provinceCode}-${parentCity}-${neighbourhoodCode}`;
        } else {
          // Fallback for provinces without city dropdowns
          const titleCode = labelToSkuPartMap[title] || title;
          const typeCode = labelToSkuPartMap[type] || type;
          const provinceCode = window.provinceToSkuPartMap[province] || province;
          const neighbourhoodCode = labelToSkuPartMap[neighbourhood] || neighbourhood;
          
          console.log('🔍 Fallback SKU Generation:', {
            titleCode: titleCode,
            typeCode: typeCode,
            provinceCode: provinceCode,
            neighbourhoodCode: neighbourhoodCode
          });
          
          return `${titleCode}-${typeCode}-${provinceCode}-${neighbourhoodCode}`;
        }
      } else {
        // For provinces with city dropdowns, city is at index 3, neighbourhood at index 4
        const city = labels[3];
        let neighbourhood = labels[4];
        
        console.log('🔍 Neighbourhood Logic Debug (With City Dropdown):', {
          title: title,
          type: type,
          province: province,
          city: city,
          neighbourhood: neighbourhood,
          labelsLength: labels.length,
          allLabels: labels
        });
        
        // Get the neighbourhood mapping
        const directMapping = labelToSkuPartMap[neighbourhood];
        const foundMapping = Object.entries(labelToSkuPartMap).find(([key]) => 
          key.toLowerCase() === neighbourhood?.toLowerCase()
        );
        const neighbourhoodMapping = directMapping || foundMapping?.[1];
        
        console.log('🔍 Detailed Mapping Debug (With City):', {
          neighbourhood: neighbourhood,
          directMapping: directMapping,
          foundMapping: foundMapping,
          finalMapping: neighbourhoodMapping,
          hasDirectKey: neighbourhood in labelToSkuPartMap,
          objectKeys: Object.keys(labelToSkuPartMap).filter(key => key.includes('ALBRO') || key.includes('HALIFAX'))
        });
        
        console.log('🔍 Neighbourhood Mapping Debug (With City):', {
          neighbourhood: neighbourhood,
          neighbourhoodMapping: neighbourhoodMapping,
          hasMapping: !!neighbourhoodMapping,
          containsDash: neighbourhoodMapping?.includes('-')
        });
        
        if (neighbourhoodMapping && neighbourhoodMapping.includes('-')) {
          // If the mapping contains a dash, it's in format "PARENT-NEIGHBOURHOOD"
          const [parentCity, neighbourhoodCode] = neighbourhoodMapping.split('-');
          
          // Use mapped codes instead of raw labels
          const titleCode = labelToSkuPartMap[title] || title;
          const typeCode = labelToSkuPartMap[type] || type;
          const provinceCode = window.provinceToSkuPartMap[province] || province;
          const cityCode = labelToSkuPartMap[city] || city;
          
          return `${titleCode}-${typeCode}-${provinceCode}-${parentCity}-${neighbourhoodCode}`;
        } else {
          // Standard neighbourhood format
          const titleCode = labelToSkuPartMap[title] || title;
          const typeCode = labelToSkuPartMap[type] || type;
          const provinceCode = window.provinceToSkuPartMap[province] || province;
          const cityCode = labelToSkuPartMap[city] || city;
          const neighbourhoodCode = labelToSkuPartMap[neighbourhood] || neighbourhood;
          
          console.log('🔍 Standard Neighbourhood SKU Generation:', {
            titleCode: titleCode,
            typeCode: typeCode,
            provinceCode: provinceCode,
            cityCode: cityCode,
            neighbourhoodCode: neighbourhoodCode
          });
          
          return `${titleCode}-${typeCode}-${provinceCode}-${cityCode}-${neighbourhoodCode}`;
        }
      }
    */
  }

  function updateSkuDisplay() {
    const labels = getCleanedLabels();
    const sku = generateSkuFromDropdowns();
    skuDisplay.textContent = 'SKU: ' + (sku || '-');
    console.log('🧩 Live Generated SKU:', sku);

    const regionType = labels[1];
    // For neighbourhoods, check if we have 4 or 5 dropdowns based on province
    const provincesWithoutCityDropdowns = ['PRINCE EDWARD ISLAND', 'NOVA SCOTIA', 'MANITOBA'];
    const isProvinceWithoutCityDropdown = labels[2] && provincesWithoutCityDropdowns.includes(labels[2]);
    const expectedLength = regionType === 'N' ? (isProvinceWithoutCityDropdown ? 4 : 5) : 4;

    if (labels.length < expectedLength || labels.includes('')) {
      stockStatus.textContent = 'Please Select Your Title Below';
      return;
    }

    cartButtons(sku);
    syncSkuToHiddenInput(sku);
  }

  function cartButtons(sku) {
    // Fast local inventory check (no network delay)
    const isSkuAvailable = availableSkuSet.has(sku);
    
    stockStatus.textContent = isSkuAvailable ? '✔️ This Title Is Available' : '❌ Not Available';
  
    const addToCartBtn = document.querySelector('form[action^="/cart/add"] button[type="submit"], form[action^="/cart/add"] .product-form__submit');
    const paypalComponent = document.querySelector('shopify-paypal-button');
  
    if (addToCartBtn) {
      addToCartBtn.disabled = !isSkuAvailable;
      addToCartBtn.textContent = isSkuAvailable ? 'Add to cart' : '❌ Title Not Available';
      addToCartBtn.style.cursor = isSkuAvailable ? 'pointer' : 'not-allowed';
    }
  
    if (paypalComponent) {
      paypalComponent.style.pointerEvents = isSkuAvailable ? 'auto' : 'none';
      paypalComponent.style.opacity = isSkuAvailable ? '1' : '0.5';
    }
  }

  function syncSkuToHiddenInput(sku) {
    const productForm = document.querySelector('form[action^="/cart/add"]');
    if (!productForm) return;

    // Sync the generated SKU
    let skuInput = document.querySelector('input[name="properties[Generated SKU]"]');
    if (!skuInput) {
      skuInput = document.createElement('input');
      skuInput.type = 'hidden';
      skuInput.name = 'properties[Generated SKU]';
      productForm.appendChild(skuInput);
    }
    skuInput.value = sku;

    // Get all dropdown selections
    const labels = getCleanedLabels();
    
    // Define field names for each dropdown position
    const fieldNames = [
      'Full Name',
      'Designation', 
      'Province/Territory',
      'Municipality/City',
      'Neighbourhood'
    ];

    // Create hidden inputs for each dropdown selection
    labels.forEach((label, index) => {
      if (label && index < fieldNames.length) {
        const fieldName = fieldNames[index];
        let input = document.querySelector(`input[name="properties[${fieldName}]"]`);
        
        if (!input) {
          input = document.createElement('input');
          input.type = 'hidden';
          input.name = `properties[${fieldName}]`;
          productForm.appendChild(input);
        }
        
        input.value = label;
      }
    });

    // Add Date Selected
    let dateInput = document.querySelector('input[name="properties[Date Selected]"]');
    if (!dateInput) {
      dateInput = document.createElement('input');
      dateInput.type = 'hidden';
      dateInput.name = 'properties[Date Selected]';
      productForm.appendChild(dateInput);
    }
    dateInput.value = new Date().toLocaleDateString('en-CA');

    // Add total number of selections
    let selectionsInput = document.querySelector('input[name="properties[Total Selections]"]');
    if (!selectionsInput) {
      selectionsInput = document.createElement('input');
      selectionsInput.type = 'hidden';
      selectionsInput.name = 'properties[Total Selections]';
      productForm.appendChild(selectionsInput);
    }
    selectionsInput.value = labels.length;
  }

  function initSkuTracking() {
    const waitForOptions = setInterval(() => {
      const filledItems = Array.from(document.querySelectorAll('.ts-control .item'))
        .filter(el => el.textContent.trim() !== '');
      const dropdowns = document.querySelectorAll('select.mw-option__control--type-select');
  
      if (filledItems.length >= 4 && dropdowns.length > 1) {
        clearInterval(waitForOptions);
        updateSkuDisplay();
  
        const observer = new MutationObserver(updateSkuDisplay);
        document.querySelectorAll('.ts-control').forEach(control => {
          observer.observe(control, { childList: true, subtree: true });
        });
  
        dropdowns.forEach((select, index) => {
          select.addEventListener('change', () => {
            // 🆕 Re-query dropdowns in case the DOM changed (e.g. switching between Region Type M and N)
            const currentDropdowns = document.querySelectorAll('select.mw-option__control--type-select');
  
            for (let i = index + 1; i < currentDropdowns.length; i++) {
              const downstream = currentDropdowns[i];
              safelyResetDropdown(downstream);
            }
  
            updateSkuDisplay();
          });
        });
  
        console.log('✅ APO options detected. SKU tracking initialized with purging.');
      }
    }, 300);
  }

  // First fetch available SKUs, then initialize tracking
  fetchAvailableSkus().then(() => {
    initSkuTracking();
    startInventoryRefresh(); // Start periodic inventory refresh
    
    // Log initial inventory health
    setTimeout(() => {
      logInventoryHealth();
    }, 1000);
  });

  // Listen for form submissions to track purchases
  document.addEventListener('submit', function(event) {
    const form = event.target;
    if (form.action && form.action.includes('/cart/add')) {
      const skuInput = form.querySelector('input[name="properties[Generated SKU]"]');
      if (skuInput && skuInput.value) {
        const sku = skuInput.value;
        console.log('🛒 Purchase detected for SKU:', sku);
        
        // Remove SKU from local inventory immediately (fast response)
        removeSkuFromInventory(sku);
        
        // Note: The webhook server will automatically receive the purchase data
        // from Shopify when the order is created, so we don't need to manually
        // notify it. The server processes Shopify webhooks at /webhook/order
        console.log('✅ SKU removed from local inventory. Webhook will be notified by Shopify.');
      }
    }
  });

  // Expose functions for debugging and testing
  window.generateSkuFromDropdowns = generateSkuFromDropdowns;
  window.getCleanedLabels = getCleanedLabels;
  window.generateSkuFromLabels = generateSkuFromLabels;
  window.removeSkuFromInventory = removeSkuFromInventory;
  window.logInventoryHealth = logInventoryHealth;
  window.availableSkuSet = availableSkuSet;
  window.getRelatedSkus = getRelatedSkus;
  window.normalizeLabel = normalizeLabel;
  window.buildMunicipalitySku = buildMunicipalitySku;
  window.buildNeighbourhoodSku = buildNeighbourhoodSku;
});

